/* eslint-disable react/prop-types */
// TODO add missing proptypes and remove above line
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import styles from '../../../constants/styles'

// TODO fix
// eslint-disable-next-line react/prop-types
const ReferralCode = ({ code, marginBottom, marginTop }) => (
  <Container marginBottom={marginBottom} marginTop={marginTop}>
    <Label>Your referral code will be:</Label>
    <Code>{code.toUpperCase()}</Code>
  </Container>
)

ReferralCode.propTypes = {
  viewer: PropTypes.string.isRequired,
  marginBottom: PropTypes.string,
  marginTop: PropTypes.string
}

ReferralCode.defaultProps = {
  marginBottom: '0',
  marginTop: '0'
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  justify-content: center;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid ${styles.colors.darkGrey};
  margin-bottom: ${(props) => props.marginBottom};
  margin-top: ${(props) => props.marginTop};
  background-color: #f8fafa;
`
const Label = styled.p`
  color: ${styles.colors.darkGrey};
  margin-bottom: 4px;
  font-size: 16px;
`
const Code = styled.p`
  color: ${styles.colors.black};
  margin-top: 4px;
  font-size: 16px;
  font-weight: 600;
`
export default ReferralCode
